export enum PdfActions {
    Open = 'Open',
    Download = 'Download',
    Generate = 'Generate',
    Print = 'Print',
}